import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Star, Briefcase } from 'lucide-react';

export default function Artikel10GeschenkeMaenner() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Alle Ratgeber
          </Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4">
            <Calendar className="w-4 h-4" />
            <span>Aktualisiert: Februar 2026</span>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">
            10 Geschenke für Männer, die jeder Muslim lieben wird
          </h1>
          <p className="text-lg text-white/80 leading-relaxed">
            Von Oud-Parfüms über Gebetszubehör bis zu stilvollen Accessoires – 
            die besten Eid-Geschenkideen für Väter, Brüder, Ehemänner und Freunde.
          </p>
        </div>
      </section>

      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-[#2C332E] leading-relaxed mb-8">
              Männer zu beschenken gilt oft als schwierig – aber mit den richtigen Ideen 
              ist es ganz einfach. Muslimische Männer schätzen Geschenke, die praktisch, 
              hochwertig und idealerweise spirituell bedeutsam sind. Hier sind 10 
              Geschenkideen, die garantiert gut ankommen.
            </p>

            <div className="bg-[#F5F5F0] rounded-2xl p-6 md:p-8 mb-12">
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">📖 Übersicht</h2>
              <ul className="space-y-2 text-[#4A5D4F]">
                <li><a href="#duefte" className="hover:underline">1-3. Düfte & Parfüms</a></li>
                <li><a href="#gebet" className="hover:underline">4-6. Gebetszubehör</a></li>
                <li><a href="#accessoires" className="hover:underline">7-10. Accessoires & Lifestyle</a></li>
              </ul>
            </div>

            {/* Düfte */}
            <section id="duefte" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                  <Briefcase className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  Düfte & Parfüms
                </h2>
              </div>
              
              <p className="text-[#4B5563] leading-relaxed mb-6">
                Oud (Adlerholz) ist der König der orientalischen Düfte und bei muslimischen 
                Männern besonders beliebt. Der tiefe, holzige Duft symbolisiert Eleganz und Tradition.
              </p>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">1. Swiss Arabian Parfum-Geschenkset</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Luxuriöses Parfumset mit orientalischen Düften – Oud, Amber und Moschus. 
                    Elegant verpackt und perfekt als Geschenk für besondere Anlässe.
                  </p>
                  <p className="text-sm text-[#4A5D4F] font-medium mt-2">Ab 60,00 €</p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">2. RITUALS Velvet Oudh Geschenkset</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Vier luxuriöse Produkte für Bad, Körper und Raumduft. Der betörende Duft 
                    von Oud und orientalischen Noten für den modernen Mann.
                  </p>
                  <p className="text-sm text-[#4A5D4F] font-medium mt-2">Ab 69,90 €</p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">3. Attar-Öl (Konzentriertes Parfüm)</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Traditionelle, alkoholfreie Parfümöle. Hochkonzentriert und langanhaltend. 
                    Beliebte Düfte: Oud, Amber, Moschus und Sandelholz.
                  </p>
                  <p className="text-sm text-[#4A5D4F] font-medium mt-2">Ab 20,00 €</p>
                </div>
              </div>
            </section>

            {/* Gebetszubehör */}
            <section id="gebet" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                  <Gift className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  Gebetszubehör
                </h2>
              </div>

              <p className="text-[#4B5563] leading-relaxed mb-6">
                Religiöses Zubehör ist ein bedeutungsvolles Geschenk, das täglich verwendet 
                wird und den spirituellen Alltag bereichert.
              </p>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">4. Hochwertige Tasbih (Gebetskette)</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine elegante Gebetskette aus Holz, Stein oder Halbedelsteinen. 
                    33 oder 99 Perlen für das tägliche Dhikr. Auch als Accessoire tragbar.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">5. Premium-Gebetsteppich</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Hochwertiger, weicher Gebetsteppich mit integriertem Kompass und 
                    Tragetasche. Ideal für Reisen und das Büro.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">6. Quran mit Leder-Einband</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine elegante Quran-Ausgabe mit hochwertigem Leder-Einband. 
                    Mit Übersetzung und Tafsir – ein Geschenk fürs Leben.
                  </p>
                </div>
              </div>
            </section>

            {/* Accessoires */}
            <section id="accessoires" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                  <Briefcase className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  Accessoires & Lifestyle
                </h2>
              </div>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">7. Hochwertige Armbanduhr</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine klassische Armbanduhr ist ein zeitloser Klassiker. Elegant für 
                    das Eid-Gebet, praktisch für den Alltag.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">8. Leder-Geldbörse</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine hochwertige Geldbörse aus echtem Leder. Praktisch, elegant 
                    und langlebig – ein Geschenk, das täglich verwendet wird.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">9. Islamische Kalligraphie (Kunstwerk)</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Ein gerahmter Kunstdruck mit arabischer Kalligraphie – Ayat al-Kursi, 
                    Bismillah oder 99 Namen Allahs. Für Büro oder Zuhause.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">10. Bakhoor & Räucherstäbchen-Set</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Hochwertiger Bakhoor (Weihrauch) mit Räuchergefäß. Schafft eine 
                    besondere Atmosphäre für Gebete und besondere Anlässe.
                  </p>
                </div>
              </div>
            </section>

            {/* Conclusion */}
            <section className="mb-12">
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-6">
                Fazit
              </h2>
              <p className="text-[#4B5563] leading-relaxed mb-4">
                Das beste Geschenk für einen muslimischen Mann ist eines, das seine Interessen 
                anspricht und seine Spiritualität unterstützt. Ob praktisch wie eine Uhr, 
                duftend wie ein Parfüm oder spirituell wie eine Tasbih – die Intention zählt.
              </p>
              <p className="text-xl text-[#4A5D4F] font-medium">
                Eid Mubarak! 🌙
              </p>
            </section>

            {/* Internal Links */}
            <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
              <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
              <ul className="space-y-2">
                <li><Link to="/ratgeber/15-geschenke-frauen" className="text-[#4A5D4F] hover:underline">→ 15 einzigartige Geschenke für Frauen</Link></li>
                <li><Link to="/ratgeber/25-geschenke-kinder" className="text-[#4A5D4F] hover:underline">→ 25 beste Eid Geschenke für Kinder</Link></li>
                <li><Link to="/ratgeber/beste-eid-geschenke-2026" className="text-[#4A5D4F] hover:underline">→ Die besten Eid Geschenke 2026</Link></li>
              </ul>
            </div>

            <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
              <h3 className="font-serif text-2xl font-medium text-white mb-4">
                Geschenke für Männer entdecken
              </h3>
              <Link
                to="/geschenke/maenner"
                className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors"
              >
                Jetzt stöbern
                <Gift className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}
